import PathNode from "./pathNode";

class Edge {
    constructor(public nodeA: PathNode, public nodeB: PathNode, public weight: number) {}
}

export default Edge;